import { Box, CircularProgress } from '@mui/material';
import { useContext, useEffect } from 'react';
import { AuthContext } from '../Context/AuthProvider';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();
  const { currentUser, fetchingUser, setCurrentUser } = useContext(AuthContext);

  useEffect(() => {
    if (currentUser) {
      navigate('/Interpreter/Dashboard');
    } else {
      navigate('/login');
    }
  }, [currentUser]);

  return (
    <Box sx={{ width: '100svw', height: '100svh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress size={40} color="secondary" />
    </Box>
  )
}